import * as React from "react";
import {
    SwitchViewStyle,
    Description,
    BigTrack,
    BigThumb,
    TextArea,
    Title,
    CompactTrack,
    CompactThumb,
    CompactSwitchWrapper,
    BigSwitchWrapper,
    FavoriteWrapper,
    FavoriteFull,
    FavoriteEmpty,
    Spinner,
} from "./switch-view-style";
import { SwitchVisual } from "./switch-view-types";
import { assertNever, isEmptyOrUndefined } from "common/Support";
import { withTheme } from "styled-components";
import { RuntimeTheme } from "../../../lib/theme/default-theme";

interface Props {
    readonly checked: boolean;
    readonly onChanged: (newValue: boolean) => void;
    readonly isEnabled: boolean;
    readonly theme: RuntimeTheme;
    readonly visual: SwitchVisual;
    readonly allowWrapping: boolean;

    readonly title?: string;
    readonly description?: string;
    readonly showSpinner?: boolean;
}

class SwitchViewImpl extends React.PureComponent<Props> {
    private onClick = () => {
        this.props.onChanged(!this.props.checked);
    };

    public render(): React.ReactNode {
        let sw: React.ReactNode;
        const { checked, visual, title, description, isEnabled, showSpinner, allowWrapping } = this.props;

        const spinner = showSpinner ? <Spinner /> : null;
        const labelFor = `switch-${title}`;

        if (visual === "switch") {
            if (this.props.theme.navBar.style === "Android") {
                sw = (
                    <CompactSwitchWrapper role="switch" aria-checked={checked} onClick={this.onClick} id={labelFor}>
                        <CompactTrack checked={checked} />
                        <CompactThumb checked={checked}>{spinner}</CompactThumb>
                    </CompactSwitchWrapper>
                );
            } else {
                sw = (
                    <BigSwitchWrapper role="switch" aria-checked={checked} onClick={this.onClick} id={labelFor}>
                        <BigTrack checked={checked} />
                        <BigThumb checked={checked}>{spinner}</BigThumb>
                    </BigSwitchWrapper>
                );
            }
        } else if (visual === "favorite") {
            if (checked) {
                sw = (
                    <FavoriteWrapper role="switch" aria-checked={checked} onClick={this.onClick} id={labelFor}>
                        <FavoriteFull />
                    </FavoriteWrapper>
                );
            } else {
                sw = (
                    <FavoriteWrapper role="switch" aria-checked={checked} onClick={this.onClick} id={labelFor}>
                        <FavoriteEmpty />
                    </FavoriteWrapper>
                );
            }
        } else {
            assertNever(visual);
        }

        return (
            <SwitchViewStyle
                className={allowWrapping ? "wrap" : "no-wrap"}
                data-test="app-switch-view"
                isEnabled={isEnabled}
                onClick={this.onClick}>
                <TextArea htmlFor={labelFor}>
                    <Title>{title}</Title>
                    {!isEmptyOrUndefined(description) && <Description>{description}</Description>}
                </TextArea>
                {sw}
            </SwitchViewStyle>
        );
    }
}

const SwitchView = withTheme(SwitchViewImpl);
export default SwitchView;
